import type { CardInstanceId, GameState, LaneId, PlayerId } from "../types";

export const MAX_ARMY_CARDS_PER_LANE = 5 as const;

export interface GarrisonSnapshot {
  readonly armyCount: number;
  readonly totalArmySize: number;
  readonly armyCardInstanceIds: readonly CardInstanceId[];
}

export function getGarrisonSnapshot(
  state: Readonly<GameState>,
  playerId: PlayerId,
  laneId: LaneId,
): GarrisonSnapshot {
  const armies = state.lanes[laneId].players[playerId].armies;
  return {
    armyCount: armies.length,
    totalArmySize: armies.reduce((total, army) => total + army.armySize, 0),
    armyCardInstanceIds: armies.map((army) => army.cardInstanceId),
  };
}

export function getArmyCount(
  state: Readonly<GameState>,
  playerId: PlayerId,
  laneId: LaneId,
): number {
  return getGarrisonSnapshot(state, playerId, laneId).armyCount;
}

export function getTotalArmySize(
  state: Readonly<GameState>,
  playerId: PlayerId,
  laneId: LaneId,
): number {
  return getGarrisonSnapshot(state, playerId, laneId).totalArmySize;
}
